module.exports = __webpack_public_path__ + "img/title.c0d29eec.png";